import React from 'react';
import ReactDOM from 'react-dom/client';
import PyrolysisCalculator from './Pyrolysis_Calculator_Bilingual';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <PyrolysisCalculator />
  </React.StrictMode>,
);
